import React from 'react';

const Experience = () => {
  return (
    <div className="experience-container">
      <h1>Work Experience</h1>
      <div className="experience">
        <h2>Software Development Engineer II</h2>
        <h3>April 2025 - Present</h3>
        <h3>
          <i>Amazon Web Services, Seattle, WA</i>
          <br />
          <i>AWS Bedrock Guardrails</i>
        </h3>
        <ul>
          <li>Served as engineering liaison to the Bedrock Guardrails Science team, a team of PhD Machine Learning scientists</li>
          <li>Developed infrastructure for scientists for model evaluation, compute scheduling, dataset storage</li>
          <li>Led a cross-team effort with science and security teams, reducing Content Filter time-to-update from 4 weeks to 1</li>
          <li>Built programmatic tool calling and deterministic multi-agent orchestration tools for Kiro, Amazon&apos;s agentic AI</li>
          <li>Built a privacy-preserving evaluation system that tests candidate models against live production</li>
          <li>Launched LLM backed&nbsp;
            <a href="https://aws.amazon.com/blogs/machine-learning/tailor-responsible-ai-with-new-safeguard-tiers-in-amazon-bedrock-guardrails/">
              guardrail tiers
            </a>
            , now processing over 1 billion tokens/minute for over 60 languages
          </li>
          <li>Built enforced Guardrails on every LLM call across AWS Organizations, hardened via full AppSec pentest</li>
          <li>Optimized and deployed vLLM inference containers for Guardrail Image Filter for multi-GPU instances</li>
        </ul>
      </div>

      <div className="experience">
        <h2>Software Development Engineer</h2>
        <h3>September 2023 - April 2025</h3>
        <h3>
          <i>Amazon Web Services, Seattle, WA</i>
          <br />
          <i>AWS Bedrock Guardrails</i>
        </h3>
        <ul>
          <li>Launched customer-configurable&nbsp;
            <a href="https://docs.aws.amazon.com/bedrock/latest/userguide/guardrails-sensitive-filters.html">
              PII detection guardrails
            </a>
            &nbsp;for AWS Bedrock, now processing 250M tokens/minute
          </li>
          <li>Increased language model performance 84% with Flash Attention and classification heads,&nbsp;
            <a href="https://aws.amazon.com/about-aws/whats-new/2025/02/amazon-bedrock-guardrails-increase-service-quota-limits/">
              increasing throughput
            </a>
          </li>
          <li>With these optimizations, reduced hosting costs by 64% across our 4000 GPU fleet,&nbsp;
            <a href="https://aws.amazon.com/about-aws/whats-new/2024/12/amazon-bedrock-guardrails-reduces-pricing-85-percent/">
              reducing customer costs
            </a>
          </li>
          <li>Leveraged AWS CDK Infrastructure-as-Code to deploy across 31 AWS regions with 99.99% availability</li>
        </ul>
      </div>

      <div className="experience">
        <h2>Software Development Engineer</h2>
        <h3>August 2022 - September 2023</h3>
        <h3>
          <i>Amazon Web Services, Seattle, WA</i>
          <br />
          <i>AWS IoT Greengrass</i>
        </h3>
        <ul>
          <li>Using AWS CDK IaC, implemented native AWS canary services to monitor the health of our product</li>
        </ul>
      </div>

      <div className="experience">
        <h2>Software Development Engineer Intern</h2>
        <h3>May 2021 - September 2021</h3>
        <h3>
          <i>Amazon Web Services, Seattle, WA</i>
          <br />
          <i>AWS IoT Device Ecosystem</i>
        </h3>
        <ul>
          <li>Designed and implemented a cloud based hardware mutex for collaboration and automation in software testing</li>
        </ul>
      </div>

      <div className="experience">
        <h2>Research Assistant, Full-time</h2>
        <h3>December 2020 - May 2021</h3>
        <h3>
          <i>Computer Science Department at Dartmouth College, Hanover, NH</i>
        </h3>
        <ul>
          <li>Aggregated, summarized, and anonymized 20 years of campus Wi-Fi usage data for research distribution</li>
          <li>Independently developed research questions, programmed targeted scripts, and created powerful visualizations</li>
        </ul>
      </div>
      <h1>Education</h1>

      <div className="experience">
        <h2>
          Dartmouth College
        </h2>
        <h3>
          Sept 2018 - June 2022
        </h3>

        <h3>
          Major in Computer Science, Minor in Engineering
        </h3>
      </div>

    </div>
  );
};

export default Experience;
